import styled from 'styled-components';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';

export const ViewActivityLogTooltip = () => {
  return (
    <TooltipContainer>
      <Text>
        <NamedContentEntryText refKey="scoreBreakdownTooltips" container="span" subKey="generalInfo" />
      </Text>
    </TooltipContainer>
  );
};
const TooltipContainer = styled.div`
  padding: 8px;
  width: max-content;
  max-width: 350px;
`;
const Text = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 400;
  color: inherit;
  text-align: start;
`;
